import { AppState } from '@app/app-state';
import { createFeatureSelector } from '@ngrx/store';
import { ClientStateState } from './client-state-state';
import { FEATURE_KEY } from './feature-key';

export const selectClientState = createFeatureSelector<
AppState,
ClientStateState
>(FEATURE_KEY);
